<template>
	<div style="padding: 10px 0;">
		<!-- 每个分布一组 -->
		<div v-for="(item, idx) in imageList" :key="idx" style="margin-bottom: 16px; position: relative; padding: 12px; border: 1px solid #e8e8e8; border-radius: 4px;">
			<!-- 删除该分布 -->
			<a-icon type="close-circle"
				style="position: absolute; top: 8px; right: 8px; font-size: 20px; color: #f5222d; cursor: pointer; z-index: 10;"
				@click="deleteItem(idx)" />
			<!-- 分布名称 表单 -->
			<a-form layout="inline" style="margin-bottom: 8px;">
				<a-form-item label="分布名称">
					<a-input v-model="item.brandLine" placeholder="分布名称" style="width: 200px" @input="syncParent" />
				</a-form-item>
			</a-form>

			<!-- 上传封面 表单 -->
			<a-form layout="inline">
				<a-form-item label="上传图片">
					<div>
						<!-- 图片预览列表（可拖拽排序） -->
						<div :ref="'dragList_' + idx" style="display: flex; flex-wrap: wrap; gap: 10px;">
							<div v-for="(imgUrl, imgIdx) in item.imageArr" :key="imgUrl" :data-img-idx="imgIdx"
								style="position: relative; cursor: grab;">
								<viewer :images="item.imageArr">
								<img :src="imgUrl" style="width: 80px; height: 80px; object-fit: cover;">
							</viewer>
								<div style="position: absolute; top: -8px; right: -8px; background: red; color: white;
                width: 20px; height: 20px; border-radius: 50%; text-align: center;
                line-height: 18px; cursor: pointer; z-index: 5;" @click="deleteImg(item, imgIdx)">×</div>
							</div>

							<!-- 图片上传按钮 -->
							<span class="upload-btn-wrapper">
								<a-spin :spinning="item._uploading" size="small">
									<input type="file" accept="image/*" multiple @change="handleFile($event, item)" style="display: none;"
										:ref="'file_' + idx" />
									<div @click="$refs['file_' + idx][0].click()" style="width: 80px; height: 80px; border: 1px dashed #ccc;
              display: flex; align-items: center; justify-content: center; cursor: pointer;">
										<a-icon type="plus" />
									</div>
								</a-spin>
							</span>
						</div>
						<div style="color: #999; font-size: 12px; margin-top: 4px;">支持多选上传，只能上传jpg/png格式文件，单文件不能超过3M</div>
					</div>
				</a-form-item>
			</a-form>
		</div>

		<a-button type="primary" @click="addItem" style="margin-top: 10px;">
			+ 添加项（图片）
		</a-button>
	</div>
</template>

<script>
	import Sortable from 'sortablejs'
	import {
		ossUpload
	} from "../../../utils/oss";
	export default {
		props: {
			errors: {
				type: Array,
				default: () => []
			},
			value: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {
				imageList: [],
				sortableInstances: [],
				_dragging: false
			};
		},
		watch: {
			value: {
				deep: true,
				immediate: true,
				handler(val) {
					if (this._dragging) return;
					// 后端分号字符串转为图片数组
					this.imageList = val.map(item => ({
						factoryEnvironmentId: item.factoryEnvironmentId || null,
						factoryLangId: item.factoryLangId || null,
						brandLine: item.brandLine || '',
						factoryImages: item.factoryImages || '',
						factoryEnvironmentType: 'IMAGE',
						imageArr: item.factoryImages ? item.factoryImages.split(';') : [],
						_uploading: false
					}));
					this.$nextTick(() => {
						this.initSortable();
					});
				}
			}
		},
		beforeDestroy() {
			this.destroySortable();
		},
		methods: {
			// 初始化拖拽排序
			initSortable() {
				this.destroySortable();
				this.$nextTick(() => {
					this.imageList.forEach((item, idx) => {
						const el = this.$refs['dragList_' + idx];
						if (el && el[0]) {
							const sortable = Sortable.create(el[0], {
								animation: 150,
								filter: '.upload-btn-wrapper',
								forceFallback: true,
								onStart: () => {
									this._dragging = true;
								},
								onEnd: (evt) => {
									const { oldIndex, newIndex } = evt;
									if (oldIndex !== undefined && newIndex !== undefined && oldIndex !== newIndex) {
										const moved = item.imageArr.splice(oldIndex, 1)[0];
										item.imageArr.splice(newIndex, 0, moved);
									}
									// 延迟同步，避免 watch 在拖拽结束瞬间触发
									this.$nextTick(() => {
										this._dragging = false;
										this.syncParent();
									});
								}
							});
							this.sortableInstances.push(sortable);
						}
					});
				});
			},
			destroySortable() {
				this.sortableInstances.forEach(s => s.destroy());
				this.sortableInstances = [];
			},

			// 新增条目
			addItem() {
				this.imageList.push({
					factoryEnvironmentId: null,
					factoryLangId: null,
					brandLine: '',
					factoryImages: '',
					imageArr: [],
					_uploading: false
				});
				this.syncParent();
				this.$nextTick(() => {
					this.initSortable();
				});
			},
			// 删除整个分布
			deleteItem(idx) {
				this.imageList.splice(idx, 1);
				this.syncParent();
			},

			// 删除单张图片
			deleteImg(item, imgIdx) {
				item.imageArr.splice(imgIdx, 1);
				this.syncParent();
			},

			// 图片上传（支持多文件 + 3MB 限制）
			async handleFile(e, item) {
				const files = Array.from(e.target.files);
				if (!files.length) return;

				// 文件大小校验：单文件不超过 3MB
				for (const f of files) {
					if (f.size > 3 * 1024 * 1024) {
						this.$message.warning('图片大小不能超过3M');
						e.target.value = '';
						return;
					}
				}

				this.$set(item, '_uploading', true);
				const uploads = files.map(f => ossUpload(f, '', 'image/'));
				Promise.all(uploads)
					.then(results => {
						item.imageArr.push(...results.map(r => r.url));
						this.syncParent();
					})
					.catch(() => {
						this.$message.error('图片上传失败');
					})
					.finally(() => {
						this.$set(item, '_uploading', false);
						e.target.value = '';
					});
			},

			// 同步数据到父组件，数组转回分号拼接字符串
			syncParent() {
				const result = this.imageList.map(item => ({
					factoryEnvironmentId: item.factoryEnvironmentId,
					factoryLangId: item.factoryLangId,
					brandLine: item.brandLine,
					factoryImages: item.imageArr.join(';'),
					factoryEnvironmentType: 'IMAGE'
				}));
				this.$emit("input", result);
			}
		}
	};
</script>
